export const panelStyle = {
  borderTop: '1px solid #F1F1F1',
};

export const playerHeight = '533px';

// cspell:ignore j2uzrhlksa
export const placeholderVideoMediaId = 'j2uzrhlksa';
